import React, { useEffect, useState } from 'react';
import {Table, Container, Button} from 'react-bootstrap';
import classes from '../../WebsiteManagement/websiteManagement.module.css';
import Page from '../../pagination/pagination';

const ActivityAvailabilityAndPriceList = (props)=>{
    const [dataSet,updateDataSet] = useState([1]);
    const [count,updateCount] = useState(0)
    const postPerPage = 20;
    const [currentPage,updateCurrentPage] = useState(1);
    const indexOfLast = currentPage*postPerPage;
    const indexOfFirst = indexOfLast - postPerPage;
    const currentPosts = dataSet.slice(indexOfFirst,indexOfLast);
    const handleChangePage = (event,value)=>{
        updateCurrentPage(value)
    }
    useEffect(()=>{
        updateCount(Math.ceil(dataSet.length/postPerPage))
    },[dataSet])
 
    return(
        <Container fluid style={{padding:'0'}}>
            <Table striped bordered hover responsive>
                <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Vendor ID</th>
                        <th>TG ID</th>
                        <th>Price ID</th>
                        <th>Duration</th>
                        <th>Cost Type</th>
                        <th>Maximum Price</th>
                        <th>Customer Price</th>
                        <th>ZT Price</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        currentPosts.length>0?currentPosts.map((data,key)=>
                            <tr key={key}>
                                <td>{key+1}</td>
                                <td>{data.vendorId}</td>
                                <td>{data.tgId}</td>
                                <td>{data.priceId}</td>
                                <td>{data.duration}</td>
                                <td>{data.costType}</td>
                                <td>{data.maximumPrice}</td>
                                <td>{data.customerPrice}</td>
                                <td>{data.ztPrice}</td>
                                <td className={classes.CenterRow}>
                                    <Button style={{marginRight:'5px'}} variant="danger">Delete</Button>
                                    <Button style={{marginRight:'5px'}}>View</Button>
                                    
                                </td>
                            </tr>
                        ):null
                    }
                </tbody>
            </Table>
            <div style={{display:'flex',justifyContent:'center',margin:'15px 0'}}>
                <Page count={count} change={handleChangePage} page={currentPage}/> 
            </div>
        </Container>
    )
}
export default ActivityAvailabilityAndPriceList;